"use strict";

var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _utils = require("../utils");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ProductsListCell = /*#__PURE__*/function (_react$default$Compon) {
  function ProductsListCell() {
    _classCallCheck(this, ProductsListCell);
    return _callSuper(this, ProductsListCell, arguments);
  }
  _inherits(ProductsListCell, _react$default$Compon);
  return _createClass(ProductsListCell, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return (0, _utils.shouldCellComponentUpdate)(this.props, nextProps) || this.state !== nextState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        cell = _this$props.cell,
        uriTransformer = _this$props.uriTransformer,
        showProduct = _this$props.showProduct,
        intl = _this$props.intl,
        defaultLanguage = _this$props.defaultLanguage;
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "tsku-products-list-cell",
        style: {
          fontFamily: cell.font
        }
      }, cell.products.filter(function (p) {
        return (0, _utils.isProductVisible)(p);
      }).map(function (product) {
        var name = (0, _utils.i18nData)(product, 'name', intl, defaultLanguage);
        var price = (0, _utils.i18nData)(product, 'price', intl, defaultLanguage);
        var shortDescription = (0, _utils.i18nData)(product, 'short_description', intl, defaultLanguage);
        var smallImageUri = (0, _utils.i18nData)(product, 'small_image_uri', intl, defaultLanguage);
        var longDescription = (0, _utils.htmlTextData)((0, _utils.i18nData)(product, 'long_description', intl, defaultLanguage));
        var largeImageUri = (0, _utils.i18nData)(product, 'large_image_uri', intl, defaultLanguage);
        var haveDetails = largeImageUri || longDescription;
        var havePhoto = !!smallImageUri;
        var onlyName = !havePhoto && !shortDescription;
        return /*#__PURE__*/_react.default.createElement("li", {
          key: product.id,
          className: "tsku-product".concat(onlyName ? ' tsku-product-name_only' : havePhoto ? ' tsku-product-with_photo' : ''),
          style: {
            backgroundColor: cell.background_color,
            color: cell.text_color
          },
          onClick: function onClick() {
            if (haveDetails) showProduct(product, cell);
          }
        }, !!smallImageUri && /*#__PURE__*/_react.default.createElement("div", {
          className: "tsku-product-img"
        }, /*#__PURE__*/_react.default.createElement("img", {
          className: "tsku-background-image",
          src: uriTransformer(smallImageUri),
          alt: "product-thumbnail"
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "tsku-product-content"
        }, /*#__PURE__*/_react.default.createElement("h2", {
          className: "tsku-product-title"
        }, /*#__PURE__*/_react.default.createElement("span", null, haveDetails && /*#__PURE__*/_react.default.createElement("span", {
          className: "tsku-product-small-button"
        }, "+"), name), !!price && /*#__PURE__*/_react.default.createElement("span", {
          className: 'tsku-product-price'
        }, price)), /*#__PURE__*/_react.default.createElement("p", {
          className: "tsku-product-description"
        }, shortDescription)));
      }));
    }
  }]);
}(_react.default.Component);
_defineProperty(ProductsListCell, "whyDidYouRender", true);
_defineProperty(ProductsListCell, "defaultProps", {
  uriTransformer: function uriTransformer(u) {
    return u;
  }
});
var _default = exports.default = (0, _reactIntl.injectIntl)(ProductsListCell);